import{d as r}from"./chunk-FORCS6Y4.js";import{s as i}from"./chunk-UUPWCWDG.js";import{b as o}from"./chunk-BOVH6WAG.js";import{m as t}from"./chunk-HBP5N4FR.js";t();i();function p(e){return r(n=>o(n,e))}export{p as a};
//# sourceMappingURL=chunk-K5HKQP5R.js.map
